import { render, staticRenderFns } from "./DeliverableTemplateDashboard.vue?vue&type=template&id=39b20a44&"
import script from "./DeliverableTemplateDashboard.vue?vue&type=script&lang=js&"
export * from "./DeliverableTemplateDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports